import { useParams } from 'react-router-dom';

const useGetBibleUrlParams = () => {
  const { book, chapter, verse, translations } = useParams();

  return {
    book: Number(book),
    chapter: Number(chapter),
    verse: Number(verse),
    translations,
  };
};

export default useGetBibleUrlParams;
